import { Map as iMap } from 'immutable';
const initialState = {
  currentRoute: '',
  previousRoute: '',
};

export function route(state = initialState, { payload, type }) {
  switch (type) {
    case '@@router/LOCATION_CHANGE':
      if (payload.action === 'REPLACE') {
        return {
          currentRoute: payload.pathname,
          previousRoute: state.previousRoute,
        };
      }
      return {
        currentRoute: payload.pathname,
        previousRoute: state.currentRoute,
      };
    case 'CLEAR_STORES':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/route/route-reducer.js